import { render, staticRenderFns } from "./topValue.vue?vue&type=template&id=62cf2db1&scoped=true&"
import script from "./topValue.vue?vue&type=script&lang=js&"
export * from "./topValue.vue?vue&type=script&lang=js&"
import style0 from "./topValue.vue?vue&type=style&index=0&id=62cf2db1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf2db1",
  null
  
)

export default component.exports